(function () {
    'use strict';

    angular.module('swif.reservations')

    .directive('recurrenteReservation', recurrenteReservation)
    .directive('listGroup', listGroup)
    .directive('reservationHeader', reservationHeader)
    .directive('reservationDownloadReport',  reservationDownloadReport)
    .directive('reservationRequester', reservationRequester)
    .directive('panelReservation', panelReservation)
    .directive('panelReservationRequest', panelReservationRequest)
    .directive('reservationResources', reservationResources)
    .directive('thumbnailResource', thumbnailResource)
    .directive('reservationLines', reservationLines)
    .directive('requestBookingsNavbar', requestBookingsNavbar)
    .directive('requestRecurrencesNavbar', requestRecurrencesNavbar)
    .directive('swifWidgetAttendee', swifWidgetAttendee);

    thumbnailResource.$inject = ['swifFrameworkService'];
    function thumbnailResource (swif) {
        var filter = {fields: ['name', 'type_prod', 'type']};
        var ret = swif.panel.create_directive('product', filter);
        ret.scope.light = '=?';
        ret.templateUrl = 'partials/openresa/thumbnail-resource.html';
        return ret;
    }

    reservationLines.$inject = ['swifFrameworkService'];
    function reservationLines (swif) {
        var directive = swif.panel.create_directive('reservation', undefined);
        directive.scope.limit = '=?';
        directive.scope.pictures = '=?';
        directive.templateUrl = 'partials/openresa/reservation-lines.html';
        return directive;
    }

    requestBookingsNavbar.$inject = ['swifFrameworkService', 'swifDownloadService', 'dataService'];
    function requestBookingsNavbar (swif, swifDownloadService, dataService) {
        return {
            restrict: 'E',
            scope: {
                model: '=',
                current: '=?',
                label: '@?',
                readonly: '=?',
                fnctRemoveBooking: '&?',
                fnctSetActiveBooking: '&?'
            },
            link: function (scope) {
                scope.getReport = function (data){
                  if (data.action.id === 'print') {
                      //sanitize the model
                      if (_.isArray(data.model._report)) {
                          data.model._report = data.model._report[0];
                      }
                      return dataService.downloadReport(
                          data.model._type,
                          data.model._report,
                          [data.model.id],
                          data.model,
                          data.model.context
                      ).then(function () {
                          if (data.model.printParams) {
                              swifDownloadService.params = data.model.printParams;
                          }
                          return true;
                      });
                  }
                }

                // i only use the lines on arguments, to help angular to recompute this method only when necessary
                scope.bookingStates = swif.settings.app.contentTypes.reservation.states;
                scope.currentPage = 1;
                scope.displayResources = function (lines) {
                    var ret = [];
                    _.forEach(lines, function (line) {
                        ret.push(line.resource.name);
                    });
                    return ret.join(', ');
                };

                scope.setActiveBooking = function (booking) {
                    if (scope.fnctSetActiveBooking) {
                        scope.fnctSetActiveBooking({$booking: booking});
                    }
                };

                scope.removeBooking = function (booking) {
                    if (scope.fnctRemoveBooking) {
                        scope.fnctRemoveBooking({$booking: booking});
                    }
                };
            },
            templateUrl: 'partials/openresa/request_bookings_navbar.html'
        };
    }

    function requestRecurrencesNavbar (swif) {
        var ret = requestBookingsNavbar(swif);
        ret.templateUrl = 'partials/openresa/request_recurrences_navbar.html';
        return ret;
    }

    swifWidgetAttendee.$inject = ['swifFormUtility'];
    function swifWidgetAttendee (swifFormUtility) {
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/openresa/widgetAttendee.html';
        d.scope.callback = '&?';
        d.link = function (scope, element, attr, ngModel) {
            scope.$watch('proxy', function (newV) {
                if (newV) {
                    var lower = angular.lowercase(newV);
                    if (lower !== newV) {
                        scope.proxy = lower;
                    }
                }
            });

            scope.doCallback = function () {
                if (scope.callback && scope.proxy) {
                    scope.callback({swifWidgetAttendee: scope.proxy});
                    scope.proxy = '';
                }
            };
            swifFormUtility.falseProxyLink(scope, element, attr, ngModel);
        };
        return d;
    }

    function recurrenteReservation () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                recurrence: '='
            },
            link: function () {
                console.log('Directive RecurrenteReservation');
            },
            templateUrl: 'partials/openresa/recurrente_reservation_directive.html'
        };
    }
    function listGroup () {
        return {
            restrict: 'E',
            require: 'ngModel',
            transclude: true,
            scope: {
                col: '='
            },
            link: function (scope, element, attr, ngModel) {
                console.log('Directive listGroup');
                ngModel.$render = function () {
                    scope.items = ngModel.$modelValue;
                };

                scope.colspan = scope.col || 1;
                // force the colspan to be dividable by 12
                scope.colspan -= 12 % scope.colspan;

                scope.iterator = _.range(0, scope.colspan, 1);
                scope.sizeClass = 'col-md-' + 12 / scope.colspan;
            },
            templateUrl: 'partials/openresa/list_group_directive.html'
        };
    }
    function reservationHeader () {
        return {
            restrict: 'E',
            transclude: true,
            require: 'ngModel',
            scope: {
                'occurrences': '=?'
            },
            link: function (scope, attribute, attrs, ngModel) {
                console.log('Directive reservationHeader');
                ngModel.$render = function () {
                    scope.model = ngModel.$viewValue;
                    scope.model.firstCheckin = scope.model.checkin;
                    scope.model.lastCheckout = scope.model.checkout;
                };
                scope.$watch('occurrences', function (newV, oldV) {
                    if(oldV !== newV && newV) {

                        scope.model.lastCheckout = _.max(newV, function (item) {
                            return moment.utc(item.checkout);
                        }).checkout;
                        scope.model.firstCheckin = _.min(newV, function (item) {
                            return moment.utc(item.checkin);
                        }).checkin;
                    }
                });
            },
            templateUrl: 'partials/openresa/reservation_header.html'
        };
    }
    reservationDownloadReport.$inject = ['swifFrameworkService'];
    function reservationDownloadReport (swif) {
        // @deprecated: use the framework directive, download-attachment instead of this one
        return {
            restrict: 'E',
            transclude: true,
            require: 'ngModel',
            scope: {
                mode: '@?'
            },
            link: function (scope, attribute, attrs, ngModel) {
                console.log('Directive reservationDownloadReport');
                ngModel.$render = function () {
                    scope.reportId = ngModel.$viewValue;
                };
                scope.currentSession = swif.settings.get('token');
            },
            templateUrl: 'partials/openresa/request_download_report.html'
        };
    }
    reservationRequester.$inject = ['swifFrameworkService'];
    function reservationRequester (swif) {
        var linked = function (scope) {
            scope.$watch('item', function (newV) {
                if (newV) {
                    if (newV.partner_invoice_id) {
                        var filter = {};
                        filter.fields = ['email', 'phone', 'mobile'];
                        swif.data.get('partner_address', newV.partner_invoice_id[0], filter)
                        .then(function (data) {
                            scope.partner_address = data;
                        });
                    }
                }
            });
        };
        var directive = swif.panel.create_directive('reservation', undefined, linked);
        directive.scope.print = '=?';
        directive.templateUrl = 'partials/openresa/requester.html';
        return directive;
    }

    function panelReservation (swif, openresa) {
        'ngInject';
        var linked = function (scope) {
            scope.$watch('item', function (newV, oldV) {
                if (oldV !== newV && scope.item) {
                    openresa.bookings.init(scope.item);
                    openresa.bookings.fetch(scope.item);
                }
            });
        };
        var directive = swif.panel.create_directive('reservation', {fields: openresa.planning.PANEL_FIELDS}, linked);
        directive.templateUrl = 'partials/openresa/panel-reservation.html';
        return directive;
    }
    panelReservationRequest.$inject = ['swifFrameworkService'];
    function panelReservationRequest (swif) {
        var directive = swif.panel.create_directive('reservationRequest');
        directive.templateUrl = 'partials/openresa/panel-reservation-request.html';
        return directive;
    }
    reservationResources.$inject = ['swifFrameworkService'];
    function reservationResources (swif) {
        var linked = function (scope) {
            let isManager = swif.user.getAccessRights().HOTEL_MANA ? true : false;
            var update = function () {
                var ret = [];
                scope.resourceNamesObject = [];
                scope.hasHumanResources = false;
                _.forEach(scope.item.resource_names, function (resource) {
                    if (!isManager &&
                        (resource[2] === 'user' ||
                        resource[2] === 'team' ||
                        resource[2] === 'organization')) {
                            scope.hasHumanResources = true;
                    } else {
                        ret.push(resource[1]);
                        scope.resourceNamesObject.push({
                            _type: 'resource',
                            id: resource[0],
                            name: resource[1],
                            type_prod: resource[2]
                        });
                    }
                });

                scope.resourceNames = ret.join(', ');
                ret = [];
            };
            scope.$watch('item.resource_names', function (newV) {
                if (newV) {
                    update();
                }
            }, true);
            scope.$watch('item', function (newV) {
                if (newV) {
                    if (!newV.resource_names) {
                        var params = {fields: ['resource_names']};
                        swif.data.get(newV._type || 'reservation', newV.id, params).then(function (data){
                            scope.item.resource_names = data.resource_names;
                            update();
                        });
                    }
                }
            });
        };
        var directive = swif.panel.create_directive('reservation', undefined, linked);
        directive.scope.pictures = '=?';
        directive.templateUrl = 'partials/openresa/resources.html';
        return directive;
    }

})();
